import React, { useState, useEffect, useRef } from "react";
import "./StringInput.css";
import InputX from "./InputX";
import { Input } from "antd";
// Removed CheckCircleOutlined import - checkmark removed for performance

const StringInput = ({
  id,
  title,
  value,
  onValueChange,
  width = "180px",
  disabled = false,
  hideX = false,
  showCheckmark = true, // New prop to enable/disable checkmark
  ...props
}) => {
  // Use local state for immediate UI update - no waiting for parent state
  const [localValue, setLocalValue] = useState(value || "");
  const debounceTimerRef = useRef(null);
  
  // Sync local state when value prop changes (from parent)
  useEffect(() => {
    if (value !== undefined && value !== localValue) {
      setLocalValue(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  
  // Handle input change - update local state immediately for instant UI feedback
  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue); // Update local state immediately - instant UI update
    
    // Cancel previous animation frame if exists
    if (debounceTimerRef.current) {
      cancelAnimationFrame(debounceTimerRef.current);
    }
    
    // Use requestAnimationFrame for parent update - runs on next frame (~16ms at 60fps)
    // This is faster than setTimeout and doesn't block the UI thread
    // It batches updates with the browser's rendering cycle for optimal performance
    debounceTimerRef.current = requestAnimationFrame(() => {
      onValueChange(newValue);
      debounceTimerRef.current = null;
    });
  };
  
  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        cancelAnimationFrame(debounceTimerRef.current);
      }
    };
  }, []);

  return (
    <div className={"string-input-wrapper tw-px-1"}>
      <div className={"string-input-title"}>{title}</div>
      <div className="string-input-container" style={{ position: 'relative' }}>
        <Input
          id={id}
          value={localValue}
          disabled={disabled}
          onChange={handleChange}
          allowClear
          // Removed suffix checkmark to improve typing performance
          // The checkmark was causing re-renders on every keystroke
          {...props}
        />
      </div>
    </div>
  );
};

export default StringInput;
